import ReactJson from "react-json-view";
import React from "react";
import { geometry as geometryArea } from "@mapbox/geojson-area";
import PopupDataEditor from "./popup_data_editor";
import QRCode from "./qr_code_tab"
import { setDefaults } from "./utils"

export default class Popup extends React.Component {
  state = {
    tab: "Properties"
  };
  setTab = tab => {
    this.setState({ tab });
  };

  editProps = (props) => {
    const { editProperties } = this.props
    editProperties(props);
  }

  editPropsWithoutMap = (props) => {
    const { editProperties } = this.props
    editProperties(props);
  }

  render() {
    const tabs = ["Properties", "Hotspot Properties"];
    const { tab } = this.state;
    const { editPropsWithoutMap, editProps } = this;
    const { layer, popupRemoveLayer, metadata, map } = this.props;
    const { properties } = layer.toGeoJSON();
    return (
      <div>
        <div className="bb flex fw6">
          {tabs.map(name => (
            <span
              key={name}
              onClick={() => this.setTab(name)}
              className={`db pointer bn pa2 outline-0 ${tab === name ? "bg-light-blue" : ""}`}>
              {name}
            </span>
          ))}
          <div style={{ flex: "1" }}/>
          <button
            className="prettyButton"
            style={{ marginTop: "auto", marginBottom: "auto", marginRight: "16px" }}
            onClick={() => { map.closePopup() }}
          >
            Close
          </button>
        </div>
        {tab === "Properties" ? (
          <div className="pa2">
            <PopupDataEditor
              layer={layer}
              onQuickChange={editPropsWithoutMap}
              onChange={editProps}
              src={properties}
              metadata={metadata}
            />
            {/* <ReactJson
              name="properties"
              displayDataTypes={false}
              onEdit={editProperties}
              onAdd={editProperties}
              onDelete={editProperties}
              enableClipboard={false}
              src={properties}
            /> */}
          </div>
        ) : tab === "Hotspot Properties" ? (
          <Metadata markerLayer={layer} onChange={editProps} />
        ) /*: tab === "QR Code" ? (
          <QRCode markerLayer={layer} metadata={metadata} />
        )*/ : null}
        <div className="bt flex fw6">
          <span
            className="db pointer bn pa2 hover-bg-light-blue"
            onClick={() => popupRemoveLayer(layer)}>
            X Delete Hotspot
          </span>
        </div>
      </div>
    );
  }
}



const Metadata = ({ markerLayer, onChange }) => {

  let { properties } = markerLayer.toGeoJSON()

  properties = setDefaults(properties);

  const handleChange = (event) => {
    const target = event.target;
    properties[target.name] = target.type === "checkbox" ? target.checked : target.value;
    onChange(properties)
  }

  // Parse audio properties into sanitized bool values
  properties.audioPlayerVisible = properties.audioPlayerVisible === "true" || properties.audioPlayerVisible === true ? true : false;
  properties.audioLoop = properties.audioLoop === "true" || properties.audioLoop === true ? true : false;
  properties.audioPlayUntilEnd = properties.audioPlayUntilEnd === "true" || properties.audioPlayUntilEnd === true ? true : false;
  properties.audioContinueOnReEntry = properties.audioContinueOnReEntry === "true" || properties.audioContinueOnReEntry === true ? true : false;
  properties.audioFadeOnEntry = properties.audioFadeOnEntry === "true" || properties.audioFadeOnEntry === true ? true : false;
  properties.audioFadeOnExit = properties.audioFadeOnExit === "true" || properties.audioFadeOnExit === true ? true : false;

  const { geometry } = markerLayer.toGeoJSON();
  
  if (geometry.type === "Point") {
    const {
      coordinates: [longitude, latitude]
    } = geometry;

    const {
      audioLayer,
      areaDisplayStyle,
      audioPlayerVisible,
      audioLoop,
      audioPlayUntilEnd,
      audioContinueOnReEntry,
      audioFadeOnEntry,
      audioFadeOnEntryDuration,
      audioFadeOnExit,
      audioFadeOnExitDuration,
    } = properties;
    const DisplayStyle = () => (
      <select name="areaDisplayStyle" value={areaDisplayStyle} onChange={handleChange}>
        <option value="none">None</option>
        <option value="area">Area</option>
      </select>
    );
    return (
      <Table
        obj={{
          Latitude: latitude.toFixed(4),
          Longitude: longitude.toFixed(4),
          Area_display_style: <DisplayStyle />,
          Audio_layer: <div>
            <input className="prettyInput input" type="number" name="audioLayer" defaultValue={audioLayer} onChange={handleChange} />
            <p style={{ marginTop: "0px", marginBottom: "0px", marginLeft: "20px" }}>Highest number plays first</p>
          </div>,
          Audio_player_visible: <input className="input" type="checkbox" name="audioPlayerVisible" defaultChecked={audioPlayerVisible} onChange={handleChange} />,
          Audio_loop: <input className="input" type="checkbox" name="audioLoop" defaultChecked={audioLoop} onChange={handleChange} />,
          Audio_play_until_end: <input className="input" type="checkbox" name="audioPlayUntilEnd" defaultChecked={audioPlayUntilEnd} onChange={handleChange} />,
          Audio_continue_on_reentry: <input className="input" type="checkbox" name="audioContinueOnReEntry" defaultChecked={audioContinueOnReEntry} onChange={handleChange} />,
          Audio_fade_on_entry: <input className="input" type="checkbox" name="audioFadeOnEntry" defaultChecked={audioFadeOnEntry} onChange={handleChange} />,
          Audio_fade_on_entry_duration: <div className={`${!audioFadeOnEntry && 'hide'}`}>
            <input className="prettyInput input" type="number" name="audioFadeOnEntryDuration" defaultValue={audioFadeOnEntryDuration} onChange={handleChange} />
            <p style={{ marginTop: "0px", marginBottom: "0px", marginLeft: "20px" }}>Seconds</p>
          </div>,
          Audio_fade_on_exit: <input className="input" type="checkbox" name="audioFadeOnExit" defaultChecked={audioFadeOnExit} onChange={handleChange} />,
          Audio_fade_on_exit_duration: <div className={`${!audioFadeOnExit && 'hide'}`}>
            <input className="prettyInput input" type="number" name="audioFadeOnExitDuration" defaultValue={audioFadeOnExitDuration} onChange={handleChange} />
            <p style={{ marginTop: "0px", marginBottom: "0px", marginLeft: "20px" }}>Seconds</p>
          </div>,
        }}
      />
    );
  } else if (geometry.type === "Polygon") {
    const area = geometryArea(geometry);

    const {
      audioLayer,
      areaDisplayStyle,
      audioPlayerVisible,
      audioLoop,
      audioPlayUntilEnd,
      audioContinueOnReEntry,
      audioFadeOnEntry,
      audioFadeOnEntryDuration,
      audioFadeOnExit,
      audioFadeOnExitDuration,
    } = properties;
    const DisplayStyle = () => (
      <select name="areaDisplayStyle" value={areaDisplayStyle} onChange={handleChange}>
        <option value="none">None</option>
        <option value="area">Area</option>
      </select>
    );
    return (
      <Table
        obj={{
          "Sq. Meters": area.toFixed(2),
          "Sq. Kilometers": (area / 1000000).toFixed(2),
          "Sq. Feet": (area / 0.092903).toFixed(2),
          Acres: (area / 4046.86).toFixed(2),
          "Sq. Miles": (area / 2589990).toFixed(2),
          Area_display_style: <DisplayStyle />,
          Audio_layer: <input className="prettyInput input" type="number" name="audioLayer" defaultValue={audioLayer} onChange={handleChange} />,
          Audio_player_visible: <input className="input" type="checkbox" name="audioPlayerVisible" defaultChecked={audioPlayerVisible} onChange={handleChange} />,
          Audio_loop: <input className="input" type="checkbox" name="audioLoop" defaultChecked={audioLoop} onChange={handleChange} />,
          Audio_play_until_end: <input className="input" type="checkbox" name="audioPlayUntilEnd" defaultChecked={audioPlayUntilEnd} onChange={handleChange} />,
          Audio_continue_on_reentry: <input className="input" type="checkbox" name="audioContinueOnReEntry" defaultChecked={audioContinueOnReEntry} onChange={handleChange} />,
          Audio_fade_on_entry: <input className="input" type="checkbox" name="audioFadeOnEntry" defaultChecked={audioFadeOnEntry} onChange={handleChange} />,
          Audio_fade_on_entry_duration: <div className={`${!audioFadeOnEntry && 'hide'}`}>
            <input className="prettyInput input" type="number" name="audioFadeOnEntryDuration" defaultValue={audioFadeOnEntryDuration} onChange={handleChange} />
            <p style={{ marginTop: "0px", marginBottom: "0px", marginLeft: "20px" }}>Seconds</p>
          </div>,
          Audio_fade_on_exit: <input className="input" type="checkbox" name="audioFadeOnExit" defaultChecked={audioFadeOnExit} onChange={handleChange} />,
          Audio_fade_on_exit_duration: <div className={`${!audioFadeOnExit && 'hide'}`}>
            <input className="prettyInput input" type="number" name="audioFadeOnExitDuration" defaultValue={audioFadeOnExitDuration} onChange={handleChange} />
            <p style={{ marginTop: "0px", marginBottom: "0px", marginLeft: "20px" }}>Seconds</p>
          </div>,
        }}
      />
    );
  } else if (geometry.type === "LineString") {
    const { coordinates } = geometry;
    let total = 0;
    for (var i = 0; i < coordinates.length - 1; i++) {
      const a = coordinates[i];
      const b = coordinates[i + 1];
      total += L.latLng(a[1], a[0]).distanceTo(L.latLng(b[1], b[0]));
    }
    return (
      <Table
        obj={{
          Meters: total.toFixed(2),
          Kilometers: (total / 1000).toFixed(2),
          Feet: (total / 0.3048).toFixed(2),
          Yards: (total / 0.9144).toFixed(2),
          Miles: (total / 1609.34).toFixed(2)
        }}
      />
    );
  }
  return null;
};

const Table = ({ obj }) => {
  return (
    <table className="collapse w-100">
      <tbody>
        {Object.entries(obj).map(([key, value], i) => {
          return (
            <tr key={i} className="striped--light-gray">
              <th className="pa1">{key.replace(/_/g, " ")}</th>
              <td className="pa1">{value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
